import { friendlyAppName, type FriendlyAppNameInput } from "./friendlyAppName";
import { APP_STORE_NAME_PLACEHOLDER } from "./resolveFriendlyAppNameDisplay";

export type AppSearchMatchInput = FriendlyAppNameInput;

function normalizeNeedle(query: string): string | null {
  const needle = query.trim().toLowerCase();
  return needle.length > 0 ? needle : null;
}

function fieldMatches(field: string | undefined | null, needle: string): boolean {
  const trimmed = field?.trim();
  if (!trimmed || trimmed === APP_STORE_NAME_PLACEHOLDER) return false;
  return trimmed.toLowerCase().includes(needle);
}

/** Case-insensitive substring match against friendly name and raw snapshot fields. */
export function matchesAppSearchQuery(input: AppSearchMatchInput, query: string): boolean {
  const needle = normalizeNeedle(query);
  if (!needle) return false;

  if (fieldMatches(friendlyAppName(input), needle)) return true;
  if (fieldMatches(input.displayName, needle)) return true;
  if (fieldMatches(input.appIdentifier, needle)) return true;
  if (fieldMatches(input.category, needle)) return true;

  return false;
}
